<template>
  <div class="free_lesson">
    <titleBar :title="title"></titleBar>
    <img v-for="(k,i) in data.imgList" :src="k" />
    <div class="bottom_btn" @click="modal_event">
      <div class="l_box">
        <h3>0.00</h3>
        <span>
          {{time}}
          <i
            v-if="data.courseList && data.courseList.length > 1"
            :class="{arrow_up : mark_show,arrow_down : !mark_show}"
          ></i>
        </span>
        <span>¥{{(data.originPrice/100).toFixed(2)}}</span>
      </div>
      <div v-if="data.isBuy" class="r_box payed" @click.stop>已报名</div>
      <div v-else class="r_box" @click.stop="pay_event">报名提升</div>
    </div>
    <div v-if="mark_show" class="mark" @click="modal_event">
      <div class="mark_item" ref="modal" @click.stop>
        <h3>可选课程</h3>
        <p
          v-for="(k,i) in data.courseList"
          @click="select_class(i)"
          :class="{cur : selectIndex == i}"
        >{{k.liveTime}}</p>
      </div>
    </div>
    <lesson_loading v-if="loadingLock" :status="status"></lesson_loading>
    <p v-if="toast" class="toast">{{toast}}</p>
  </div>
</template>

<script>
import ajax from "@/api/lightAjax";
import utils from "@/assets/js/utils";
import titleBar from "@/components/common/fit_iphonex/titleBar_fit_iphonex.vue";
import lesson_loading from "@/components/common/fit_iphonex/lesson_loading_fit_iphonex.vue";
let vm = null;
window.callback = function(obj) {
  vm.creatOrder(JSON.parse(obj));
};
window.onVisible = function() {
  vm.initData();
};
window.verifyParentCallback = function() {
  window.location = "hybird://method/nativeToJS?funcName=callback";
};
export default {
  name: "free_lesson",
  data() {
    return {
      title: "重难点高效提升",
      token: "",
      courseId: "",
      source: "",
      version: "",
      productId: "",
      data: {},
      selectIndex: 0,
      mark_show: false,
      loadingLock: true,
      status: "loading",
      time: "",
      toast: "",
      wechat: ""
    };
  },
  watch: {
    toast(newName, oldName) {
      let self = this;
      if (newName != "") {
        setTimeout(function() {
          self.toast = "";
        }, 2000);
      }
    }
  },
  components: {
    titleBar,
    lesson_loading
  },
  methods: {
    modal_event() {
      let self = this;
      if (this.data.courseList.length <= 1) return;
      this.mark_show = !this.mark_show;
      utils.sendLog(
        {
          token: self.token,
          version: self.version,
          source: self.source,
          extensionJson: {
            event: 2
          }
        },
        "hzxx625"
      );
    },
    select_class(i) {
      this.selectIndex = i;
      this.time = this.data.courseList[this.selectIndex].liveTime;
    },
    initData: async function() {
      let self = this;
      const [resp] = await ajax.all([
        ajax.get("/light/live-introduce/unit", {
          params: {
            token: self.token,
            courseId: self.courseId
          }
        })
      ]);
      if (resp.data.code == 99999) {
        self.loadingLock = false;
        console.log(resp.data.data);
        self.data = resp.data.data;
        self.time = self.data.courseList[self.selectIndex].liveTime;
        if (this.data.courseList.length > 1) {
          utils.sendLog(
            {
              token: self.token,
              version: self.version,
              source: self.source,
              extensionJson: {
                event: 1
              }
            },
            "hzxx625"
          );
        }
      } else {
        self.loadingLock = true;
        self.status = "error";
      }
    },
    creatOrder: async function(obj) {
      let self = this;
      let productId = self.data.courseList[self.selectIndex].productId;
      let classNumber = self.data.courseList[self.selectIndex].classNumber;
      const [resp] = await ajax.all([
        ajax.post("/light/live-order/order-add", {
          token: self.token,
          source: obj.source,
          version: obj.version,
          productId: productId,
          identity: "parent",
          userSource: "LIVENETSCHOOL",
          clientChannel: obj.channel,
          clientVersion: obj.appVersion,
          deviceBrand: obj.platform,
          deviceModel: obj.platform,
          OSName: obj.platform,
          OSVersion: obj.deviceVersion,
          pageChannel: utils.getQueryString("pageChannel") || "",
          channel: "i_xhjz"
        })
      ]);

      if (resp.data.code == 99999) {
        self.wechat = resp.data.data.teacherWechat || "";
        self.go_sucess();
      } else {
        self.toast = resp.data.msg;
      }
    },
    go_sucess() {
      let self = this;
      let version = Number(this.version);
      if (version >= 4072) {
        let classNumber = this.data.courseList[this.selectIndex].classNumber;
        this.$router.push({
          path:
            "/lightLesson/free_pay_sucess?courseId=" +
            self.courseId +
            "&token=" +
            self.token +
            "&source=" +
            self.source +
            "&version=" +
            self.version +
            "&classNumber=" +
            classNumber
        });
      } else {
        this.$router.push({
          path:
            "/lightLesson/pay_sucess?courseID=" +
            self.courseId +
            "&token=" +
            self.token +
            "&source=" +
            self.source +
            "&version=" +
            self.version +
            "&wechat=" +
            self.wechat
        });
      }
    },
    pay_event() {
      let self = this;
      let version = Number(this.version);
      utils.sendLog(
        {
          token: self.token,
          version: self.version,
          source: self.source,
          extensionJson: {
            courseID: self.courseId
          }
        },
        "hzxx626"
      );
      if (!this.data.isBuy) {
        if (version >= 4072) {
          window.location = "hybird://method/verifyParent";
        } else {
          window.location = "hybird://method/nativeToJS?funcName=callback";
        }
      } else {
        self.go_sucess();
      }
    }
  },
  created: function() {
    let self = this;
    vm = this;
    self.token = utils.getQueryString("token");
    self.courseId = utils.getQueryString("courseId");
    self.source = utils.getQueryString("source");
    self.version = utils.getQueryString("version").substr(0, 4);
    utils.sendLog(
      {
        token: self.token,
        version: self.version,
        source: self.source,
        extensionJson: {
          courseID: self.courseId,
          from: utils.getQueryString("from")
        }
      },
      "hzxx624"
    );
    self.initData();
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/font/font.scss";
.free_lesson {
  padding-top: 0.88rem;
  padding-bottom: 1rem;
  img {
    display: block;
    width: 100%;
  }
  .bottom_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1rem;
    z-index: 99;
    .l_box {
      float: left;
      padding: 0.25rem 0;
      width: 4.9rem;
      height: 1rem;
      background: #fff;
      /*box-shadow: 10px 10px 5px #40384e;*/
      box-shadow: 0px -2px 8px 0px rgba(64, 56, 78, 0.08);
      h3 {
        &:before {
          content: "¥";
          font-family: "BebasNeue_Bold";
          font-size: 0.44rem;
          color: #ff7575;
        }
        display: inline-block;
        margin-left: 0.3rem;
        margin-right: 0.2rem;
        font-family: "BebasNeue_Bold";
        font-size: 0.72rem;
        color: #ff7575;
        float: left;
      }
      span {
        display: block;
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        line-height: 0.25rem;
        color: #5f6162;
        &:last-child {
          margin-top: 0.1rem;
          font-family: "BebasNeue_Bold";
          font-size: 0.24rem;
          color: #ff9b9b;
          text-decoration: line-through;
        }
        i {
          margin-left: 0.12rem;
          display: inline-block;
          width: 0.18rem;
          height: 0.18rem;
        }
        .arrow_down {
          background: url("../../assets/images/light_lesson/arrow_down.png") 0 0 /
            cover no-repeat;
        }
        .arrow_up {
          background: url("../../assets/images/light_lesson/arrow_up.png") 0 0 /
            cover no-repeat;
        }
      }
    }
    .r_box {
      height: 1rem;
      line-height: 1rem;
      font-family: PingFangSC-Semibold;
      font-size: 0.34rem;
      color: #fff;
      text-align: center;
      background: #ff7575;
      overflow: hidden;
    }
    .payed {
      background-color: #cacbcc;
    }
  }
  .mark {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 98;
    background-color: rgba(0, 0, 0, 0.7);
    .mark_item {
      position: fixed;
      bottom: 1rem;
      z-index: 100;
      width: 100%;
      // height: 4.75rem;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      background-color: #fff;
      box-sizing: border-box;
      padding: 0.5rem 0.4rem 0.5rem;
      h3 {
        margin-bottom: 0.5rem;
        height: 0.25rem;
        line-height: 0.25rem;
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #919294;
        text-align: center;
        &:before {
          display: inline-block;
          content: "";
          margin-bottom: 0.08rem;
          margin-right: 0.2rem;
          width: 10px;
          height: 1px;
          background-color: #919294;
          border-radius: 1px;
        }
        &:after {
          display: inline-block;
          content: "";
          margin-bottom: 0.08rem;
          margin-left: 0.2rem;
          width: 10px;
          height: 1px;
          background-color: #919294;
          border-radius: 1px;
        }
      }
      p {
        margin-bottom: 0.3rem;
        width: 3.2rem;
        height: 0.8rem;
        line-height: 0.8rem;
        background-color: #fafafa;
        border-radius: 0.4rem;
        /*border: solid 2px #ff7575;*/
        box-sizing: border-box;
        font-family: PingFangSC-Medium;
        font-size: 0.26rem;
        color: #424243;
        text-align: center;
        &:nth-child(odd) {
          float: right;
        }
        &:nth-child(even) {
          float: left;
        }
      }
      .cur {
        color: #ff7575;
        border: solid 1px #ff7575;
      }
    }
  }
  .toast {
    position: fixed;
    width: 3rem;
    height: 1.5rem;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    font-family: PingFangSC-Medium;
    font-size: 0.3rem;
    line-height: 1.5rem;
    text-align: center;
    color: #fff;
    z-index: 999;
  }
}
</style>